<template>
  <div>
    <v-autocomplete
      :value="permit"
      :items="filterPermits"
      v-bind="$attrs"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :label="$i18n.t(label)"
      :rules="rules"
      @click:clear="clear"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div ripple class="height32">
          <h5 class="text-title">{{ data.item.type }}</h5>
        </div>
      </template>

      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.type }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>

      <template v-slot:append-item>
        <div class="actionBox">
          <v-btn small text color="info" @click="addPermitDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Permit") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>

    <z-permit-add
      :refreshPermits="fetchPermits"
      @closePermitDialog="closePermitDialog"
      :showDialog="addPermitDialog"
    ></z-permit-add>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { commonMixin } from "@/mixins/common";
import { doGet } from "@/store/common/module/apis";
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "PermitSelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Permit",
    },
    clearable: {
      default: false,
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class PermitSelect extends (Vue, Themeable) {
  loading = true;
  filter = "";
  addPermitDialog = false;
  permits = [];
  permit = null;

  clear() {
    this.filter = "";
    this.$emit("input", null);
  }

  closePermitDialog() {
    this.addPermitDialog = false;
  }

  async fetchPermits(_fetch) {
    if (_fetch) {
      try {
        common.setLoading(true);
        this.permits = await doGet("/api/permit/type/all");
        common.setLoading(false);
      } catch (e) {
        common.setLoading(false);
      }
    }
  }

  get filterPermits() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    const permits = this.permits;
    if (filterby == "") {
      return permits;
    } else {
      const fc = permits.filter(function (c) {
        return c.type.toLowerCase().indexOf(filterby) >= 0;
      });
      return fc;
    }
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.permit = newVal;
    if (newVal && newVal.type) {
      this.$emit("input", newVal.type);
      return;
    }
    if (!newVal) this.$emit("input", null);
  }

  async init() {
    const permits = this.permits;
    if (this.value) {
      for (let i = 0; i < permits.length; i++) {
        if (permits[i].type === this.value) {
          this.permit = permits[i];
          break;
        }
      }
    }
  }

  async mounted() {
    await this.fetchPermits(true);
    await this.init();
    this.loading = false;
  }

  selected(val) {
    if (val != null && val.type != null && this.permit != null) {
      if (Array.isArray(this.permit)) {
        for (let i = 0; i < this.permit.length; i++) {
          if (val.type === this.permit[i].type) {
            return true;
          }
        }
      } else if (this.permit != null && this.permit._id != undefined) {
        if (val.type === this.permit.type) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.permit = null;
    }
    await this.init();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
